<script setup>

import {ref} from "vue";
import {useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();

const showModal= ref(false);

const emits = defineEmits(['deleteItems', 'videoDownload', 'openModal', 'set_isFolderModal', 'showTransferModal']);




</script>

<template>
  <div class="buttonGroup_part">
    <v-btn
        color="#052C65"
        size="small"
        @click="emits('set_isMoveModal', true)"
        :text="languageStore.get('move')"
    ></v-btn>
    <v-btn
        color="#CFE2FF"
        size="small"
        @click="emits('showTransferModal')"
        :text="languageStore.get('transmission')"
    ></v-btn>
    <v-btn
        color="#CFE2FF"
        size="small"
        @click="emits('videoDownload')"
        :text="languageStore.get('download')"
    ></v-btn>
    <v-btn
        color="#CFE2FF"
        size="small"
        @click="emits('set_isFolderModal', true)"
        :text="languageStore.get('newFolder')"
    ></v-btn>
    <v-btn
        color="#CFE2FF"
        @click="emits('openModal', 'insert')"
        size="small"
        :text="languageStore.get('register')"
    ></v-btn>
    <v-btn
        color="#808695"
        @click="emits('deleteItems')"
        size="small"
        :text="languageStore.get('delete')"
    ></v-btn>



  </div>
</template>

<style scoped>
.buttonGroup_part button{
  margin: 5px;
  white-space: nowrap;
}

</style>